module.exports = __webpack_public_path__ + "static/new-zealand-flag-square-xs@2x-57f94b4c05a7e418ddcd5d156df9f945.png";